import { createImageUrl } from "services/imageUrl.service";

export const getImage = obj => {
  console.log(obj, "obj");
  let formData = new FormData();
  const values = { ...obj };
  for (let key in values) {
    values?.image?.map(ele => {
      if (ele && typeof ele == "object") {
        formData.set("image", ele);
      }
      return ele;
    });
    // formData.set(key, values[key] ? JSON.stringify(image) : JSON.stringify([]));
  }
  return createImageUrl(formData)
    .then(res => {
      console.log(res);
      return res
    })
    .catch(err => {
      console.log(err);
    });
};

export default getImage;
